import * as React from "react";

import "./folder-list-route.scss";

import {cs}              from "@Common/react/chain-services";
import {consumeContext}  from "@Common/react/context";
import {Load2}           from "@Common/react/load2";
import {sort}            from "@Common/utils/collections";
import {faSpinner}       from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {Breadcrumbs}   from "../../common/breadcrumbs/breadcrumbs";
import {rProductTiles} from "../../common/tiles/product-tiles";
import {Layout}        from "../../layout/layout";

import {rTemplateViewMore} from "../common/template-view-more";

export const FolderListRoute = ({}) => cs(
    consumeContext("apis"),
    consumeContext("company"),
    ["folders", ({apis}, next) => Load2({
        fetch: () => apis.next.userCreated.getFolders(1),
        next,
    })],
    ({company, folders, apis}) => {
        return (
            <Layout className="folder-list-route-7sa" active="catSubcatStyle">
                <div className="restrict-width-1">
                    <Breadcrumbs userCreated={true}/>

                    {folders.loading ? (
                        <div className="spinner-footer" xd-qa-type="label" xd-qa-name="Loading">
                            <FontAwesomeIcon icon={faSpinner} className="fa-pulse"/>
                        </div>
                    )  : (sessionStorage.getItem("listingId") ? !folders.value.filter((sub) => !!sub?.listingsEligible).length : !folders.value.length) ? (
                        <div className="" xd-qa-type="label" xd-qa-name="Empty">
                            No templates are available in this category!
                        </div>
                    ) : (
                        rProductTiles({
                            products: sessionStorage.getItem("listingId") ? folders.value.filter((sub) => !!sub?.listingsEligible) : folders.value,
                            getProductViewData: (folder) => ({
                                img_url: folder.image,
                                name: folder.name,
                                type: 'userCreated',
                                to: `/my-templates/${folder.idPrimary}`,
                                new_tab: undefined,
                                getIcon: () => company?.prefs.smartTemplateIcon && (
                                    <div className="icon" xd-qa-type="icon" xd-qa-name="Smart Template Icon">
                                        <img alt="Smart Template" src="/next_images/icons/SmartTemplateIcon.svg"/>
                                    </div>
                                ),
                                children: [{
                                    name: folder.name,
                                    to: `/my-templates/${folder.idPrimary}`,
                                }],
                            }),
                            view_more: {
                                getItems: async (folder) => {
                                    const folderTemplates = await apis.next.userCreated.getTemplates( folder.idPrimary, 1 );
                                    return sort(folderTemplates, (template: any) => template.sequence);
                                },
                                renderItem: (template, {viewMode}) => rTemplateViewMore(template, false, {viewMode}),
                                alwaysShow: true,
                            },
                        })
                    )}
                </div>
            </Layout>
        );
    },
);
